import { render } from "./RightNavDrawer.vue?vue&type=template&id=24b897f8"
import script from "./RightNavDrawer.vue?vue&type=script&lang=js"
export * from "./RightNavDrawer.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__